/** One identity for the visible case; only its most recent request may update the panel. */
export function previewRequests() {
  let key = '', sequence = 0
  return {
    select(next: string) { if (next !== key) { key = next; sequence++ } },
    start() { return { key, sequence: ++sequence } },
    current(ticket: { key: string; sequence: number }) { return ticket.key === key && ticket.sequence === sequence },
    invalidate() { sequence++ },
  }
}
